import './modules/video-archive.js';
import Piano from './piano/piano.js';
import AdManager from './ads/ad-manager.js';
import Toggle from './modules/toggle.ts';
import SocialShare from './modules/social-share.ts';
import ModuleInitializer from './utilities/module-initializer.ts';
import Billboard from './modules/billboard.ts';

ModuleInitializer({
	toggle: Toggle,
	'social-share': SocialShare,
	billboard: Billboard,
});

(function (app, $) {
	'use strict';

	app.instantiate = function (elem) {
		const $this = $(elem);
		const module = $this.attr('data-module');
		if (module === undefined) {
			throw 'Module not defined (use data-module="")';
		} else if (module in app && $this.attr('data-initialized') !== true) {
			new app[module](elem);
			$this.attr('data-initialized', true);
		}
	};

	$('[data-module]').each(function () {
		app.instantiate(this);
	});

	function handleFirstTab(e) {
		if (9 === e.keyCode) {
			$('body').addClass('user-is-tabbing');
			document.removeEventListener('keydown', handleFirstTab);
		}
	}

	document.addEventListener('keydown', handleFirstTab);

	$(window).on('load', function () {
		Piano.maybeInit();
		AdManager.init();
	});

	console.log(
		'%c  Powered by level-level.com 💪🏻  ',
		'background: #222; color: #fff; font-size: 14px; font-weight: normal; border-radius: 5px; line-height: 30px;',
	);
})((window.app = window.app || {}), jQuery);
